import {
  PRIMARY_API_BASE_URL,
  forgetFallbackHost,
  hasFallbackHost,
  isFallbackActive,
} from './apiHost'

/** Сколько ждём ответа при проверке. Проверка фоновая, тянуть незачем. */
const PROBE_TIMEOUT_MS = 5000

/**
 * Проверяет, ожил ли основной бэкенд, и если да — снимает запомненное
 * переключение на запасной.
 *
 * Без этой проверки схема была бы опасной: разовое падение основного бэка
 * увело бы всех на европейский сервер на сутки. Здесь же человек возвращается
 * на основной хост со следующего захода, а тот, у кого основной закрыт по
 * географии, так и остаётся на запасном — проверка у него не пройдёт никогда.
 *
 * Запрос идёт через `fetch` в режиме `no-cors`: нам нужен не ответ, а сам факт
 * что до хоста есть связь. Обычный axios-запрос здесь дал бы ложный
 * отрицательный результат — браузер отбросил бы ответ без CORS-заголовков, и
 * живой бэк выглядел бы мёртвым.
 */
export const probePrimaryHost = (): void => {
  if (!hasFallbackHost || !isFallbackActive()) return

  const abort = new AbortController()
  const timer = setTimeout(() => abort.abort(), PROBE_TIMEOUT_MS)

  void fetch(PRIMARY_API_BASE_URL, {
    method: 'GET',
    mode: 'no-cors',
    cache: 'no-store',
    signal: abort.signal,
  })
    .then(() => {
      forgetFallbackHost()
      console.info('✅ Основной бэкенд снова доступен')
    })
    .catch(() => {
      // Недоступен — остаёмся на запасном до конца срока памяти.
    })
    .finally(() => clearTimeout(timer))
}
